<template>
  <span class="form-control-feedback" v-if="isError">{{prefix}}<slot>{{defaultErrorText}}</slot>{{suffix}}</span>
</template>

<script>
  import {dd} from 'systems/imports'
    export default {
      name: "input-feedback",
      props:{
        validateForInput:Object,
        type:String,
        prefix:String,
        suffix:String,
      },
      data (){
        return {}
      },
      computed:{
        isError(){
          return this.validateForInput["$error"] && !this.validateForInput[this.type]
        },
        defaultErrorText(){
          return "error"
        },
      }

    }
</script>

<style>

</style>




// WEBPACK FOOTER //
// InputFeedback.vue?6a1970c0